import { GDSBorderRadius, GDSBorderRadii } from '@leagueplatform/genesis-core';

type RadiusTokenMap = {
  [K in keyof GDSBorderRadii]: GDSBorderRadius;
};

export const radiusTokenMap: RadiusTokenMap = {
  none: '$none',
  thin: '$thin',
  thick: '$thick',
  small: '$small',
  medium: '$medium',
  large: '$large',
  extraLarge: '$extraLarge',
  huge: '$huge',
  circle: '$circle',
  pill: '$pill',
  button: '$button',
  inputField: '$inputField',
  card: '$card',
};
